(function(){
  var root = document.querySelector('[data-tlcsr]'); if(!root) return;
  var form = root.querySelector('.tlcsr-form');
  var field = root.querySelector('.tlcsr-field');
  var input = root.querySelector('.tlcsr-input');
  var word = root.querySelector('[data-tlcsr-word]');
  var clear = root.querySelector('.tlcsr-clear');
  var results = root.querySelector('[data-tlcsr-results]');
  var searchUrl = root.getAttribute('data-search-url') || '/search';
  var suggestUrl = root.getAttribute('data-suggest-url') || '/search/suggest';
  var holdMs = parseInt(root.getAttribute('data-hold'), 10) || 1800;
  var focusPh = root.getAttribute('data-focus-ph') || '';
  var terms = [];
  try { terms = JSON.parse(root.querySelector('[data-tlcsr-terms]').textContent) || []; } catch(e){}
  terms = terms.filter(function(t){ return t && String(t).trim(); });
  if(!terms.length) terms = ['Body Mist'];

  /* ---- shadow once genuinely scrolled ----
     Positioning itself is no longer JS-driven (see the `top:0` comment in the
     <style> block above) — both this row and the nav sit at the same fixed
     `top:0` and the nav's higher z-index covers this row whenever the nav has
     height, natively, with no script. This listener is purely cosmetic: it
     adds a drop shadow once the page has scrolled at all, so the row reads as
     "on top of" the content sliding underneath it instead of flush with it. */
  var sec = root.closest('.shopify-section') || root.parentNode;
  if(sec && root.hasAttribute('data-tlcsr-sticky')){
    function syncStuck(){ sec.classList.toggle('is-stuck', window.scrollY > 0); }
    window.addEventListener('scroll', syncStuck, { passive:true });
    syncStuck();
  }

  /* ---- typewriter placeholder ---- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ti = 0, ci = 0, deleting = false, timer = null;
  function tick(){
    var t = terms[ti];
    if(!deleting){
      ci++; word.textContent = t.slice(0, ci);
      if(ci >= t.length){ deleting = true; timer = setTimeout(tick, holdMs); return; }
      timer = setTimeout(tick, 55 + Math.random()*40);
    } else {
      ci--; word.textContent = t.slice(0, ci);
      if(ci <= 0){ deleting = false; ti = (ti+1) % terms.length; timer = setTimeout(tick, 350); return; }
      timer = setTimeout(tick, 32);
    }
  }
  function startType(){ if(timer) return; if(reduce){ word.textContent = terms[0]; return; } tick(); }
  function stopType(){ if(timer){ clearTimeout(timer); timer = null; } }
  function sync(){
    var live = document.activeElement === input || input.value.length > 0;
    field.classList.toggle('is-live', live);
    form.classList.toggle('has-text', input.value.length > 0);
    if(live){ stopType(); input.placeholder = focusPh; }
    else { input.placeholder = ''; startType(); }
  }
  input.addEventListener('focus', sync);
  input.addEventListener('blur', function(){ setTimeout(sync, 0); });
  document.addEventListener('visibilitychange', function(){ if(document.hidden) stopType(); else sync(); });
  sync();

  /* ---- suggestions ---- */
  var seq = 0, deb = null, lastQ = '';
  function esc(s){ return String(s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function money(n){ var v = Math.round(parseFloat(n)); try { return '₹' + v.toLocaleString('en-IN'); } catch(e){ return '₹' + v; } }
  function hl(text, q){ var i = text.toLowerCase().indexOf(q.toLowerCase()); if(i<0) return esc(text); return esc(text.slice(0,i)) + '<mark>' + esc(text.slice(i,i+q.length)) + '</mark>' + esc(text.slice(i+q.length)); }
  function qlink(q){ return searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }
  function close(){ root.classList.remove('is-open'); }
  function open(){ root.classList.add('is-open'); }
  function render(q, data){
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [], cols = r.collections || [], qs = r.queries || [];
    if (/^(bacne|body acne|back acne|acne)$/i.test(q.trim())) { prods = prods.filter(function(p){ return /bacne|acne|salicylic/i.test((p.title || '') + ' ' + (p.type || '')); }); }
    var html = '', left = '';
    if(qs.length){ left += '<p class="tlcsr-h">Suggestions</p><ul class="tlcsr-links">' + qs.slice(0,5).map(function(x){ return '<li><a href="' + qlink(x.text) + '">' + hl(x.text, q) + '</a></li>'; }).join('') + '</ul>'; }
    if(cols.length){ left += '<p class="tlcsr-h" style="margin-top:' + (qs.length?14:0) + 'px">Collections</p><ul class="tlcsr-links">' + cols.slice(0,4).map(function(c){ return '<li><a href="' + esc(c.url) + '">' + hl(c.title, q) + '</a></li>'; }).join('') + '</ul>'; }
    if(!left){ left = '<p class="tlcsr-h">Popular</p><ul class="tlcsr-links">' + terms.slice(0,5).map(function(t){ return '<li><a href="' + qlink(t) + '">' + esc(t) + '</a></li>'; }).join('') + '</ul>'; }
    html += '<div>' + left + '</div>';
    if(prods.length){
      html += '<div><p class="tlcsr-h">Products</p><ul class="tlcsr-prods">' + prods.slice(0,6).map(function(p){
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x120_crop_center$1$2') : '';
        var price = p.price ? money(p.price) : '';
        return '<li><a href="' + esc(p.url) + '">' + (img ? '<img class="tlcsr-pi" src="' + esc(img) + '" alt="' + esc(p.title || '') + '" loading="lazy" width="56" height="56">' : '<span class="tlcsr-pi"></span>') + '<span><span class="tlcsr-pt">' + hl(p.title, q) + '</span>' + (price ? '<div class="tlcsr-pp">' + price + '</div>' : '') + '</span></a></li>';
      }).join('') + '</ul></div>';
      html += '<div class="tlcsr-all"><a href="' + qlink(q) + '">See all results for “' + esc(q) + '”</a></div>';
    } else {
      html += '<div class="tlcsr-empty">No products match “' + esc(q) + '” yet. Press Enter to search everything.</div>';
    }
    results.innerHTML = html; open();
  }
  function fetchSug(q){
    var my = ++seq;
    var url = suggestUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,vendor,variants.title,tag';
    fetch(url, { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }).then(function(d){ if(my !== seq) return; render(q, d); }).catch(function(){});
  }
  input.addEventListener('input', function(){
    sync();
    var q = input.value.trim();
    if(deb) clearTimeout(deb);
    if(q.length < 2){ close(); lastQ = ''; return; }
    deb = setTimeout(function(){ if(q === lastQ){ open(); return; } lastQ = q; fetchSug(q); }, 180);
  });
  input.addEventListener('focus', function(){ if(input.value.trim().length >= 2 && results.innerHTML) open(); });
  input.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ close(); input.blur(); } });
  clear.addEventListener('click', function(){ input.value = ''; close(); sync(); input.focus(); });
  document.addEventListener('click', function(e){ if(!root.contains(e.target)) close(); });
  form.addEventListener('submit', function(e){ if(!input.value.trim()){ e.preventDefault(); input.focus(); } });
})();

